module.exports = __webpack_public_path__ + "img/cat_tinggi.c11af99d.png";